'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { CHANGE_COLOR_ID, CHANGE_TXT_QUERY, HONORED_OPT_OUT, HONORED_OPT_OUT_COLOR, INTERVAL, NO_OPT_OUT, NO_OPT_OUT_COLOR } from '@/constants';
export default function OneTrust() {
  const $ = _c(2);
  const checkOnetrustActiveGroups = _temp;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const intervalId = setInterval(checkOnetrustActiveGroups, INTERVAL);
      return () => clearInterval(intervalId);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return null;
}
function _temp() {
  const activeGroups = (window.OnetrustActiveGroups ?? window.OptanonActiveGroups)?.split(",");
  if (activeGroups && activeGroups.length < 4) {
    const optOut = document.querySelector(CHANGE_TXT_QUERY);
    if (optOut) {
      optOut.textContent = HONORED_OPT_OUT;
    }
    const gpcSig = document.getElementById(CHANGE_COLOR_ID);
    if (gpcSig) {
      gpcSig.style.cssText = HONORED_OPT_OUT_COLOR;
    }
  } else {
    const optOut_0 = document.querySelector(CHANGE_TXT_QUERY);
    if (optOut_0) {
      optOut_0.textContent = NO_OPT_OUT;
    }
    const doc = document.getElementById(CHANGE_COLOR_ID);
    if (doc) {
      doc.style.cssText = NO_OPT_OUT_COLOR;
    }
  }
}